<template>
  <div class="main-layout">
    <!-- // TODO ส่วนที่ใช้ในการแสดง loading -->
    <div class="loading" v-show="loading && !error">
      <div class="circle-loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>

    <!-- TODO ส่วนที่ใช้แสดง Error -->
    <div class="layout-error" v-if="error">
      <ErrorPage />
    </div>

    <!-- // TODO ส่วนที่ใช้ในการ Upload ฟิล์ม X-ray -->
    <div v-show="!loading && !error" class="content">
      <!-- // TODO Tab Header -->
      <div class="layout-tab">
        <u-tab v-model="tab" :items="tabItems"></u-tab>
      </div>

      <!-- // TODO Tab Items -->
      <div class="layout-tab-content">
        <u-tab-items v-model="tab">
          <!-- // TODO Tab สำหรับการ Upload File -->
          <template v-slot:upload>
            <!-- // TODO ส่วนที่ใช้ในการเลือกโรค -->
            <div class="layout-select">
              <v-select
                item-text="name"
                item-value="service_id"
                v-model="diagnosisList"
                :items="allname"
                chips
                multiple
                outlined
                dense
                hide-details
                placeholder="เลือกโรคที่ต้องการ"
                color="primary"
              >
                <template v-slot:selection="{ item, index, value }">
                  <!-- FIX เดี๋ยวต้องมาตามแก้เพราะเขียนได้สั้นกว่านี้ -->
                  <!-- COMMENT เมื่อเป็น XS -->
                  <div v-if="$vuetify.breakpoint.xs">
                    <v-chip v-if="index <= 2" outlined color="primary" small>
                      <span>{{ item.name | TextOverFlow }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text text-caption">
                      (+{{ value.length - 3 }} โรค)
                    </span>
                  </div>
                  <!-- COMMENT เมื่อไม่ใช่ XS -->
                  <div v-else>
                    <v-chip v-if="index <= 5" outlined color="primary" small>
                      <span>{{ item.name | TextOverFlow }}</span>
                    </v-chip>
                    <span v-if="index === 6" class="grey--text text-caption">
                      (+{{ value.length - 6 }} โรค)
                    </span>
                  </div>
                </template>
              </v-select>
            </div>

            <!-- // TODO ส่วนที่ใช้ในการเลือกไฟล์ -->
            <div class="layout-upload">
              <u-upload-dragdrop
                v-model="files"
                accept="image/png, image/jpeg ,.dcm,.jpg"
                @input="CreateDataTable"
              ></u-upload-dragdrop>
            </div>

            <!-- // TODO ส่วนที่ใช้ในการดูรายละเอียดไฟล์ -->
            <div class="layout-table">
              <u-table
                :headers="headers"
                :items="items"
                :mobileBreakpoint="900"
                :showSelect="false"
                itemKey="id"
                :loading="loading"
                :pagination="pagination"
              >
                <!--  NOTE Status Upload -->
                <template v-slot:[`item.index`]="{ item }">
                  {{ items.indexOf(item) + 1 }}
                </template>

                <!-- NOTE Progress Upload -->
                <template v-slot:[`item.uploadprogress`]="{ item }">
                  <v-progress-linear
                    striped
                    class="rounded-pill"
                    :value="item.progress"
                    height="15"
                  >
                    <strong style="color: #fff">{{ item.progress }}%</strong>
                  </v-progress-linear>
                </template>

                <!--  NOTE Status Upload -->
                <template v-slot:[`item.status`]="{ item }">
                  <v-icon v-if="item.progress >= 100" color="success">
                    mdi-checkbox-marked
                  </v-icon>
                </template>

                <!-- NOTE Acrtion Upload -->
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="!(item.progress == 0)"
                        v-on="on"
                        v-bind="attrs"
                        icon
                        fab
                        x-small
                        :dark="item.uploadprogress == 0"
                        color="error"
                        @click="deleteItem(item)"
                      >
                        <v-icon>mdi-delete-forever</v-icon>
                      </v-btn>
                    </template>
                    <span>ลบ</span>
                  </v-tooltip>
                </template>
              </u-table>
            </div>

            <!-- // TODO ส่วนที่ใช้ในการยืนยันการตรวจวินิจฉัยโรค -->
            <div class="layout-actions">
              <v-row
                justify="start"
                align="center"
                dense
                style="height: 100%"
                class="pa-0 ma-0"
              >
                <v-col cols="6" sm="3" md="3">
                  <v-btn
                    :disabled="files.length <= 0"
                    color="error"
                    block
                    @click="Reset"
                    >ลบทั้งหมด</v-btn
                  >
                </v-col>
                <v-col cols="6" sm="9" md="9">
                  <v-btn
                    :disabled="
                      files.length <= 0 ||
                      diagnosisList.length <= 0 ||
                      !statusUpload
                    "
                    color="primary"
                    block
                    @click="upload"
                    >เริ่มตรวจหาโรค</v-btn
                  >
                </v-col>
              </v-row>
            </div>
          </template>

          <!-- // TODO Tab Content History -->
          <template v-slot:history>
            <HistoryIntegration
              :items="items_history"
              :pagination.sync="pagination_history"
              @onChangePagination="init_history"
              @dbclickRow="openView"
            ></HistoryIntegration>
          </template>
        </u-tab-items>
      </div>
    </div>

    <!-- // TODO เป็น Component สำหรับแสดงข้อมูลการวินิจฉัย -->
    <u-advance-history
      v-model="viewStatus"
      :src="viewImageSrc"
      :processes="viewProcesses"
      :detailItem="viewDetail"
    >
    </u-advance-history>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ErrorPage from '@/components/ErrorPage.vue'
import HistoryIntegration from '@/components/Hospital/HistoryIntegration.vue'
// import menuHistory from '@/components/Hospital/History.vue'

export default {
  components: {
    ErrorPage,
    HistoryIntegration
    // menuHistory
  },
  data () {
    return {
      // TODO Dialog view ----------------
      viewStatus: false,
      viewProcesses: [],
      viewDetail: {},
      viewImageSrc: '',

      error: false,
      tab: '',
      accessToken: '',
      hospital_id: '',
      tabItems: [
        {
          text: 'อัปโหลด',
          name: 'upload',
          verify: 1,
          disableTooltip: false,
          description: 'อัพโหลไฟล์'
        },
        {
          text: 'ประวัติ',
          name: 'history',
          verify: 1,
          disableTooltip: false,
          description: 'ดูประวัติการวินิจฉัยโรค'
        }
      ],

      queryOptions: {
        // TODO Credential
        apikey: '',
        credential: '',
        credential_type: '',
        callback: '',

        // TODO theme color -------------
        theme: '',
        color_primary: '',
        color_secondary: '',
        color_error: '',
        color_success: '',
        color_warning: ''
      },

      // ------------------------------
      files: FileList,
      tmpFiles: FileList,
      diagnosisList: [],
      allname: [],
      statusUpload: true,
      headers: [
        {
          text: 'ลำดับที่',
          align: 'center',
          value: 'index',
          sortable: false,
          width: '10%'
        },
        {
          text: 'ชื่อไฟล์',
          value: 'name',
          align: 'start',
          sortable: false,
          width: '40%'
        },
        {
          text: 'ความคืบหน้า',
          value: 'uploadprogress',
          align: 'center',
          sortable: false,
          width: '30%'
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'จัดการ',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '10%'
        }
      ],
      items: [
        // {
        //   index: 0,
        //   size: '',
        //   fileNae: '',
        //   proress: 0
        // }
      ],
      items_history: [],
      tmpItems: [],
      loading: false,
      pagination: {
        total: 0,
        page: 1,
        row: 10
      },
      pagination_history: {
        total: 0,
        page: 1,
        row: 10
      }
    }
  },
  async created () {
    // TODO Query String paser
    this.queryOptions = this.queryPaser(this.queryOptions)

    // TODO สี primary
    if (this.isColorHex(this.queryOptions.color_primary)) {
      const c = this.queryOptions.color_primary
      this.$vuetify.theme.themes.light.primary = c
      this.$vuetify.theme.themes.dark.primary = c
    }

    // TODO สี error
    if (this.isColorHex(this.queryOptions.color_error)) {
      const c = this.queryOptions.color_error
      this.$vuetify.theme.themes.light.error = c
      this.$vuetify.theme.themes.dark.error = c
    }

    // TODO สี success
    if (this.isColorHex(this.queryOptions.color_success)) {
      const c = this.queryOptions.color_success
      this.$vuetify.theme.themes.light.success = c
      this.$vuetify.theme.themes.dark.success = c
    }

    // TODO  theme
    this.$vuetify.theme.isDark = this.queryOptions.theme === 'dark'

    this.loading = true // TODO Turn On Loading

    // TODO สำหรับ login ระบบผ่าน  Api key
    const res = await this.SignInForApiKey({
      api_key: this.queryOptions.apikey,
      credential_type: this.queryOptions.credential_type,
      credential: this.queryOptions.credential
    })
    if (res.status) {
      localStorage.clear()
      // localStorage.setItem('Accesstoken', res.data.accesstoken)
      this.accessToken = res.data.accesstoken // TODO Set accesstoken to local state

      // TODO สำหรับดึงข้อมูลของโรงพยาบาลจาก Apikey
      const r = await this.GetHospitalInfoByApiKey({
        api_key: this.queryOptions.apikey
      })

      if (r.status) {
        this.hospital_id = r.data.hospital_id // TODO Set Hospital Id to Local state
        // TODO Called first function edit here -----------------
        // NOTE สำหรับแก้ปัญหา Event ไม่เคลียเมื่อมีการ Refresh Page
        this.$websocket.Disconnect()

        // NOTE สำหรับ Connect Websocket
        this.$websocket.Connect(this.accessToken)

        // NOTE เป็น Event เมื่อมีการ Upload Job
        this.$websocket.$on('upload:job', (e) => {
          this.init_history()
          this.callback('upload', e)
          // this.init_history()
        })

        // NOTE เป็น Event เมื่อ มีการ Update Job
        this.$websocket.$on('update:job', (e) => {
          this.callback('update', e)
          this.init_history()
          const data = JSON.parse(JSON.stringify(this.items_history))
          for (let index = 0; index < data.length; index++) {
            if (e.job_id === data[index].job_id) {
              data[index] = JSON.parse(JSON.stringify(e))
            }
          }
          this.items_history = JSON.parse(JSON.stringify(data))
        })

        // NOTE สำหรับดึงข้อมูล Service ที่สามารถใช้งานได้
        this.init()

        // NOTE สำหรับดึงข้อมูล History ของ User
        this.init_history()
        // TODO Edit here ---------------------------------------
      } else {
        // NOTE เมื่อไม่สามารถ Get Hospital_id ได้
        this.error = true

        // NOTE สำหรับแก้ปัญหา Event ไม่เคลียเมื่อมีการ Refresh Page
        this.$websocket.Disconnect()
      }
      this.loading = false // TODO Turn Off Loading
    } else {
      // NOTE เมื่อไม่สามารถขอ Credential ได้
      this.error = true

      // NOTE สำหรับแก้ปัญหา Event ไม่เคลียเมื่อมีการ Refresh Page
      this.$websocket.Disconnect()
    }

    // NOTE สำหรับการรับ EventBus จาก Function Background Upload
    this.$EventBus.$on('upload-progress', (val) => {
      this.items
        .filter((x) => x.id === val.id)
        .forEach((x) => {
          x.progress = val.progress
        })
    })
  },

  methods: {
    ...mapMutations(['addUploadBackground']),

    openView (val) {
      // TODO สำหรับดึงข้อมูลรายละเอียดต่างๆ
      this.viewDetail = {
        job_id: val.job_id || '-',
        po: val.resource.po || '-',
        pn: val.resource.pn || '-',
        da: val.resource.da || '-',
        create_date: val.create_date || '-',
        create_by: '-'
      }

      // TODO สำหรับดึงข้อมูลการ Process จาก AI
      this.viewProcesses = val.processes

      // TODO สำหรับดึงข้อมูลของภาพ
      this.viewImageSrc = val.resource.file

      // TODO เปิด Dialog สำหรับ ดูรายละเอียด
      this.viewStatus = true
    },
    isColorHex (str) {
      // TODO เป็น Function ในการ Check ว่าเป็น Color แบบ hexcode หรือไม่
      const regex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
      if (str == null) return false
      if (regex.test(str)) return true
      else {
        if (str.length > 0) console.warn(`${str} : not hex color format`)
        return false
      }
    },

    queryPaser (obj) {
      // TODO เป็น functin ในการ Paser Query String แล้ว Return ของออกไปตาม Object ที่ได้มีการรับมา
      const n = Object.assign({})
      Object.keys(obj).forEach((v) => (n[v] = this.$route.query[v] || ''))
      return n
    },

    async CreateDataTable (val) {
      let tmp = val
      if (!this.statusUpload) {
        // TODO Clear Old file
        tmp = await tmp.filter((x) => {
          const i = this.tmpFiles.filter((y) => {
            // TODO เมื่อมีไฟล์อยู่แล้ว
            return y.id === x.id
          })
          // TODO หากว่ามี file return false
          return !(i.length > 0)
        })

        // TODO Reset State Upload
        this.files = tmp
        this.statusUpload = true
      }

      this.items = Object.assign([])
      for (const item of tmp) {
        this.items.push({
          id: item.id,
          size: item.size,
          name: item.name,
          progress: 0
        })
      }
    },

    async init () {
      // NOTE Reset All Current State
      this.Reset()
      const payload = {
        hospital_id: this.hospital_id
      }
      const res = await this.getHospitalPackageForUpload(payload)
      // NOTE SUCCESS
      if (res.status) {
        this.allname = res.data.map((i) => {
          return {
            name: i.name,
            service_id: i.service_id
          }
        })
        this.diagnosisList = this.allname
      } else {
        // NOTE ERROR
        this.antmessage.error(res.message)
      }
    },

    async init_history () {
      // this.loading = true
      this.refresh = false
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      const payload = {
        page: this.pagination_history.page,
        row: this.pagination_history.row,
        hospital_id: this.hospital_id,
        keyword: this.keyword,
        diagnosis: this.result === 'all' ? '' : this.result,
        create_by: JSON.parse(atob(this.accessToken.split('.')[1]))?.sub
      }
      const res = await this.getHistoryForTable(payload)
      // this.loading = false
      if (res.status) {
        this.items_history = res.data.data
        // console.log(res.data.data)
        this.pagination_history = res.data.pagination
      } else {
        this.antmessage.error(res.message)
      }
    },

    async upload () {
      this.statusUpload = false
      this.CreateMultiJobForUpload(
        this.hospital_id,
        this.diagnosisList,
        this.files,
        { headers: { Authorization: `Bearer ${this.accessToken}` } }
      )
      this.tmpItems = this.items
      this.tmpFiles = this.files
      this.addUploadBackground(this.tmpItems)
    },

    deleteItem (item) {
      this.files = this.files.filter((x) => x.id !== item.id)
      this.items = this.items.filter((x) => x.id !== item.id)
    },

    Reset () {
      this.items = Object.assign([])
      this.files = Object.assign([])
      this.statusUpload = true
    },

    // NOTE ------------------------------- to mixin
    async SignInForApiKey (payload) {
      // TODO เป็น function ในการ Sign ระบบด้วย API KEY และ Credential จากระบบอื่นที่รองรับการใช้งาน
      // TODO หากว่าไม่เคยมี user ในระบบจะ create และ add user เข้าไปยังโรงพยาบาลให้โดยอัตโนมัติ
      const p = {
        ...{
          api_key: '',
          credential_type: '',
          credential: '',
          permission: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/signin/integration`,
        method: 'post',
        data: p
      }
      return await this.awaitAxios(options)
    },

    async GetHospitalInfoByApiKey (payload) {
      // TODO เป็น fucntion ในการ Get ข้อมูลของโรงพยาบาลจาก API KEY
      const p = {
        ...{
          api_key: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/apikey/${p.api_key}/info`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      }
      return await this.awaitAxios(options)
    },

    async getHospitalPackageForUpload (payload) {
      // TODO เป็น Function ในการดึงขอ้มูล ของ service ทั้งหมดที่สามารถใช้งานได้ในวันนนั้น
      // TODO โดยเป็นการ แก้ไขจาก Function ใน Mixin ที่ component อื่นมีการเรียกใช้งานอยู่
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/services`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${this.accessToken}` // TODO ส่วนที่แตกต่างจาก ใน mixin
        }
      }
      return await this.awaitAxios(options)
    },

    async getHistoryForTable (payload) {
      // TODO เป็น Function ในการดึงข้อมูลของ Job
      // TODO โดยแก้ไขจากที่อยู่ใน Mixin คือ มีการเพิ่มในส่วนของ Authorization
      const params = {
        ...{
          // Edit Constructure here
          page: 1,
          row: 10,
          keyword: '',
          diagnosis: '',
          create_by: ''
        },
        ...payload
      }
      const options = {
        url: `${process.env.VUE_APP_API}/api/v1/hospital/${payload.hospital_id}/jobs`,
        method: 'get',
        params: params,
        headers: {
          Authorization: `Bearer ${this.accessToken}` // TODO ส่วนที่แตกต่างจาก ใน mixin
        }
      }
      return await this.awaitAxios(options)
    },
    callback (event, payload) {
      if (this.queryOptions.callback !== '') {
        // COMMENT เมื่อ มีการส่ง Function Callback มาให้ใช้งาน
        if (self === top) {
          console.log('Top')
          // TODO เมื่อเป็น Page ของตัวเอง
          if (window[this.queryOptions.callback]) {
            window[this.queryOptions.callback](event, payload)
          } else {
            console.warn(`callback not found : ${this.queryOptions.callback}`)
          }
        } else {
          console.log('Iframe')
          // TODO เมื่อเป็น Iframe
          // window.parent.postMessage({
          //   func: this.queryOptions.callback,
          //   message: 'Message text from iframe.'
          // }, '*')
          window.parent.postMessage({ event: event, payload: payload }, '*')
        }
      }
    }
  },
  watch: {
    switch1 (newValue) {
      if (newValue) {
        this.selected = this.allname.map((e) => e.service_id)
      } else {
        this.selected = []
      }
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    files (x) {
      this.pagination.total = this.items.length
    }
  }
}
</script>
<style lang="scss" scoped>
.main-layout {
  max-height: 100vh;
  width: 100%;
  height: 100% !important;
  padding: 0;
  margin: 0;
  overflow: hidden;
  // background: red;
}
.content {
  padding: 0;
  width: 100%;
  height: calc(100% - 0px);
}

.loading .circle-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.layout-select {
  padding-top: 16px;
  width: 100%;
  height: 100%;
  height: calc(33.5px + 40px);
  // background: red;
}

.layout-upload {
  width: 100%;
  height: 25%;
  // background: yellow;
}
.layout-table {
  padding: 0;
  margin: 0;
  width: 100%;
  height: calc(100% - 73.5px - 25% - 48px);
  // background: pink;
}

.layout-actions {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 48px;
  // background: orchid;
}

.layout-error {
  width: 100%;
  height: 100%;
  display: inline-block;
  padding: 0;
  margin: 0;
  z-index: 999;
}

.layout-tab {
  height: 48px;
  overflow: hidden;
}
.layout-tab-content {
  width: 100%;
  height: calc(100% - 48px) !important;
  padding: 0;
  margin: 0;
  // background: red;
}

::v-deep fieldset {
  border-color: var(--v-primary-base);
}
</style>
